





















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Attending extends Vue {
  /**
   * personIsAttending
   */
  public personIsAttending() {
    this.$emit('userIsAttending', true);
  }
}
